export default {
  page_title: 'Mitglieder:innen hinzufügen',
}
